@if (loading) {
  <div class="row">
    <mat-progress-bar mode="indeterminate" color="primary"></mat-progress-bar>
  </div>
}

@if (autoSaveLoading) {
  <div class="autosave-icon-fixed">
    <mat-icon class="blink">cloud_upload</mat-icon>
  </div>
}

@if (survey) {
  <div class="row" style="background-color: #F1F2F2">
    <div [class]="isAnonymous ? 'container-fluid px-0' : 'container mt-3'" [style.background-color]="isAnonymous ? 'white' : '#F1F2F2'">
      @if (survey?.answered && !justSubmitted && !isAnonymous) {
        <div class="alert alert-info my-3 text-center" role="alert">
          {{ (answerStatus === 'SENT' ? 'generic.questionnaire-sent' : 'components.responses.info-draft-date') | translate }}
          @if (answerTimestamp) {
            @let formattedDate = answerTimestamp | formatdate | date:'short';
            @if (answerStatus !== 'SENT') {
              {{ formattedDate }}
            } @else {
              <br>
              <span>
          {{ 'components.responses.info-sent-date' | translate }} {{ formattedDate }}
        </span>
            }
          }
        </div>
      }
    @if ((!survey?.answered && !impersonateEmail) || justSubmitted) {
      <mat-stepper [linear]="true" #stepper
        style="background-color: #F1F2F2">
        <!-- Anagraphic Form Template -->
        <ng-template #anagraphicFormContent>
          <form [formGroup]="userInfoForm">
            <div class="box flex-column my-0 pb-0 pt-3 px-3 border-0">
              <mat-form-field appearance="fill">
                <mat-label>{{ "generic.name" | translate }}</mat-label>
                <input formControlName="first_name" [(ngModel)]="survey.user.first_name"
                  [required]="survey.customs?.anagraphic_is_mandatory !== false" matInput>
              </mat-form-field>
            </div>
            <div class="box flex-column my-0 pb-0 pt-3 px-3 border-0">
              <mat-form-field appearance="fill">
                <mat-label>{{ "generic.surname" | translate }}</mat-label>
                <input formControlName="last_name" [(ngModel)]="survey.user.last_name"
                  [required]="survey.customs?.anagraphic_is_mandatory !== false" matInput>
              </mat-form-field>
            </div>
            <div class="box flex-column my-0 pb-0 pt-3 px-3 border-0">
              <mat-form-field appearance="fill">
                <mat-label>{{ "generic.phone" | translate }}</mat-label>
                <input formControlName="phone_number" [(ngModel)]="survey.user.phone_number" matInput>
              </mat-form-field>
            </div>
            <div class="box flex-column my-0 pb-0 pt-3 px-3 border-0">
              <mat-form-field appearance="fill">
                <mat-label>{{ "generic.email" | translate }}</mat-label>
                <input type="email" [email]="true" [(ngModel)]="survey.user.email" formControlName="email"
                  [required]="survey.customs?.anagraphic_is_mandatory !== false" matInput>
              </mat-form-field>
            </div>

            @for (field of survey.team_member_custom_fields; track field.id) {
              @if (field.visible) {
                <div class="box flex-column my-0 pb-0 pt-3 px-3 border-0">
                  <mat-form-field appearance="fill">
                    <mat-label>{{ field.name }}</mat-label>
                    @switch (field.type) {
                      @case ('number') {
                        <input type="number" [formControlName]="field.id" [(ngModel)]="survey.user.custom_fields[field.id]" matInput>
                      }
                      @case ('date') {
                        <input type="date" [formControlName]="field.id" [(ngModel)]="survey.user.custom_fields[field.id]" matInput>
                      }
                      @case ('boolean') {
                         <mat-select [formControlName]="field.id" [(ngModel)]="survey.user.custom_fields[field.id]">
                            <mat-option [value]="true">{{ 'generic.yes' | translate }}</mat-option>
                            <mat-option [value]="false">{{ 'generic.no' | translate }}</mat-option>
                         </mat-select>
                      }
                      @default {
                        <input type="text" [formControlName]="field.id" [(ngModel)]="survey.user.custom_fields[field.id]" matInput>
                      }
                    }
                  </mat-form-field>
                </div>
              }
            }
          </form>
        </ng-template>
        <!-- START: Anagraphic Form Step -->
        @if (shouldShowAnagraphicAt('START')) {
          <mat-step [stepControl]="userInfoForm">
            <ng-template matStepLabel>{{ "generic.generic-info" | translate }}</ng-template>
            <div class="mt-5">
              <ng-container *ngTemplateOutlet="anagraphicFormContent"></ng-container>
            </div>
            <div class="row justify-content-end mt-5 mx-1">
              <button class="btn-custom border-0 d-flex align-items-center px-5 py-2" matStepperNext>
                <mat-icon class="mr-2">play_circle_outlined</mat-icon>
                {{'generic.next' | translate}}
              </button>
            </div>
          </mat-step>
        }
        <!-- Intro Step -->
        @if (!survey?.customs?.skip_introduction) {
          <mat-step>
            <div class="mt-4">
              <ng-template matStepLabel>{{ "generic.introduction" | translate }}</ng-template>
              <p class="label-box font-weight-bold">{{ "components.decision-table.new-decision-table.compile-proposal.title"
              | translate}}</p>
              <p>{{ survey?.title }}</p>
              @if (survey.description) {
                <p class="label-box font-weight-bold mt-4">{{ "generic.description" | translate}}</p>
                <app-formatted-text-preview [content]="survey?.description"></app-formatted-text-preview>
              }
              @if (survey?.attachments?.length > 0) {
                <app-attachments-list [attachments]="survey?.attachments" />
              }
              <div class="row justify-content-end mt-3">
                <button class="btn-custom border-0 d-flex align-items-center px-5 py-2" matStepperNext>
                  <mat-icon class="mr-2">play_circle_outlined</mat-icon>
                  {{'generic.next' | translate}}
                </button>
              </div>
            </div>
          </mat-step>
        }
        <!-- Questions Step -->
        <mat-step [label]="'generic.questions' | translate" [completed]="isQuestionsValid">
          <div>
            <div class="mt-5">
              <app-survey-details [surveyObj]="survey" [isResponse]="true" />
            </div>
            @if (loading) {
              <div class="row my-5">
                <mat-progress-bar mode="indeterminate" color="primary"></mat-progress-bar>
              </div>
            }
            <div class="row justify-content-between mt-3">
              <button [disabled]="loading" mat-stroked-button
                class="text-dark-purple border-purple back-btn-stroked d-flex align-items-center"
                matStepperPrevious>
                {{'generic.back' | translate}}
              </button>
              @if (survey?.customs?.draft_answer_is_enabled) {
                <button [disabled]="loading"
                  class="btn-custom border-0 d-flex align-items-center px-5 py-2 ml-auto mr-3"
                  (click)="!loading ? onSubmit(true) : ''">
                  {{'generic.buttons.save-draft' | translate}}
                </button>
              }
              <!-- Submit Button (if Anagraphic is START or PRIVATE) -->
              @if (shouldShowAnagraphicAt('START') || survey.visibility_type === 'PRIVATE') {
                <button [disabled]="loading"
                  class="btn-custom border-0 d-flex align-items-center px-5 py-2" (click)="!loading ? onSubmit() : ''">
                  <mat-icon class="mr-2">play_circle_outlined</mat-icon>
                  {{'generic.buttons.save-and-send' | translate}}
                </button>
              } @else {
                <!-- Next Button (if Anagraphic is END) -->
                <button
                  class="btn-custom border-0 d-flex align-items-center px-5 py-2"
                  (click)="validateQuestionsAndProceed(stepper)">
                  <mat-icon class="mr-2">play_circle_outlined</mat-icon>
                  {{'generic.next' | translate}}
                </button>
              }
            </div>
          </div>
        </mat-step>
        <!-- END: Anagraphic Form Step -->
        @if (shouldShowAnagraphicAt('END')) {
          <mat-step [stepControl]="userInfoForm">
            <ng-template matStepLabel>{{ "generic.generic-info" | translate }}</ng-template>
            <div class="mt-5">
              <ng-container *ngTemplateOutlet="anagraphicFormContent"></ng-container>
            </div>
            <div class="row justify-content-between mt-5 mx-1">
              <button mat-stroked-button
                class="text-dark-purple border-purple back-btn-stroked d-flex align-items-center"
                matStepperPrevious>
                {{'generic.back' | translate}}
              </button>
              <button [disabled]="loading" class="btn-custom border-0 d-flex align-items-center px-5 py-2"
                (click)="!loading ? onSubmit() : ''">
                <mat-icon class="mr-2">play_circle_outlined</mat-icon>
                {{'generic.buttons.save-and-send' | translate}}
              </button>
            </div>
          </mat-step>
        }
        <mat-step>
          <ng-template matStepLabel>{{ 'generic.done' | translate }}</ng-template>
          <div class="col-12 text-center d-flex flex-column align-items-center py-4">
            <img src="assets/img/all-sent.png" alt="" class="all-sent-img mb-3">
            <h4 class="font-weight-bold col-12 w-100 pl-0 mt-3 text-center color-primary-purple">
              {{ 'pages.surveys.response.submitted-successfully' | translate }}
            </h4>
          </div>
        </mat-step>
      </mat-stepper>
    }
    @if (survey?.answered && !justSubmitted) {
      <div class="anonymous-summary-container container-fluid py-4 px-md-5">

        <!-- Summary Dashboard: Always for Anonymous OR for Non-Anonymous DRAFTS -->
        @if (isAnonymous || answerStatus === 'DRAFT') {
            <!-- Centered Completion Badge -->
            <div class="d-flex justify-content-center mb-5">
                <div class="px-4 py-2 bg-light-purple color-primary-purple rounded-pill h5 mb-0 font-weight-bold shadow-sm border border-white">
                    {{ (answeredQuestions.length / survey.questions.length * 100) | number:'1.0-0' }}% {{ 'generic.completion' | translate }}
                </div>
            </div>

            <!-- Metrics Dashboard -->
            <div class="row mb-5">
                <div class="col-4">
                    <div class="card border-0 shadow-sm rounded-lg text-center p-3 border-bottom-success h-100">
                        <mat-icon class="text-success mb-2">check_circle_outline</mat-icon>
                        <div class="h3 font-weight-bold text-success mb-1">{{ answeredQuestions.length }}</div>
                        <div class="text-uppercase text-muted letter-spacing-1 x-small font-weight-bold">{{ 'generic.answered' | translate }}</div>
                    </div>
                </div>
                <div class="col-4">
                    <div class="card border-0 shadow-sm rounded-lg text-center p-3 border-bottom-warning h-100">
                        <mat-icon class="text-warning mb-2">pending</mat-icon>
                        <div class="h3 font-weight-bold text-warning mb-1">{{ partialQuestions.length }}</div>
                        <div class="text-uppercase text-muted letter-spacing-1 x-small font-weight-bold">{{ 'generic.partial' | translate }}</div>
                    </div>
                </div>
                <div class="col-4">
                    <div class="card border-0 shadow-sm rounded-lg text-center p-3 border-bottom-danger h-100">
                        <mat-icon class="text-danger mb-2">highlight_off</mat-icon>
                        <div class="h3 font-weight-bold text-danger mb-1">{{ missingQuestions.length }}</div>
                        <div class="text-uppercase text-muted letter-spacing-1 x-small font-weight-bold">{{ 'generic.missing' | translate }}</div>
                    </div>
                </div>
            </div>

            <!-- Question Breakdown (Details List) -->
            <div class="questions-breakdown" [class.mb-5]="!isAnonymous">
                <div class="d-flex align-items-center mb-3">
                    <div class="bg-primary-purple rounded" style="width: 4px; height: 20px;"></div>
                    <h6 class="mb-0 ml-2 text-uppercase x-small font-weight-bold text-muted letter-spacing-1">{{ 'generic.questions_details' | translate }}</h6>
                </div>

                <mat-accordion class="clean-accordion shadow-none">
                    @if (missingQuestions.length > 0) {
                        <mat-expansion-panel class="mb-2 border-left-danger shadow-sm" [expanded]="isAnonymous">
                            <mat-expansion-panel-header>
                                <mat-panel-title class="text-danger font-weight-bold small">{{ 'generic.missing' | translate }} ({{ missingQuestions.length }})</mat-panel-title>
                            </mat-expansion-panel-header>
                            @for (q of missingQuestions; track q.id) {
                                <div class="d-flex flex-column py-2 px-1 border-bottom-light">
                                    <div class="d-flex align-items-center mb-1">
                                        <mat-icon class="text-danger mr-2" style="font-size: 16px; width:16px; height:16px;">close</mat-icon>
                                        <span class="small font-weight-bold">{{ q.question }}</span>
                                    </div>
                                    <div class="ml-4 d-flex flex-wrap">
                                        @for (step of getQuestionCompletionSteps(q); track step.label) {
                                            <div class="mr-3 mb-1 d-flex align-items-center x-small">
                                                <mat-icon [class]="step.status ? 'text-success' : 'text-muted'" style="font-size: 12px; width:12px; height:12px;" class="mr-1">
                                                    {{ step.status ? 'check_circle' : 'radio_button_unchecked' }}
                                                </mat-icon>
                                                <span [class.text-muted]="!step.status">
                                                    {{ step.label | translate }}{{ step.detail ? ': ' + step.detail : '' }}
                                                </span>
                                            </div>
                                        }
                                    </div>
                                </div>
                            }
                        </mat-expansion-panel>
                    }

                    @if (partialQuestions.length > 0) {
                        <mat-expansion-panel class="mb-2 border-left-warning shadow-sm" [expanded]="isAnonymous">
                            <mat-expansion-panel-header>
                                <mat-panel-title class="text-warning font-weight-bold small">{{ 'generic.partial' | translate }} ({{ partialQuestions.length }})</mat-panel-title>
                            </mat-expansion-panel-header>
                            @for (q of partialQuestions; track q.id) {
                                <div class="d-flex flex-column py-2 px-1 border-bottom-light">
                                    <div class="d-flex align-items-center mb-1">
                                        <mat-icon class="text-warning mr-2" style="font-size: 16px; width:16px; height:16px;">hourglass_empty</mat-icon>
                                        <span class="small font-weight-bold">{{ q.question }}</span>
                                    </div>
                                    <div class="ml-4 d-flex flex-wrap">
                                        @for (step of getQuestionCompletionSteps(q); track step.label) {
                                            <div class="mr-3 mb-1 d-flex align-items-center x-small">
                                                <mat-icon [class]="step.status ? 'text-success' : 'text-danger'" style="font-size: 12px; width:12px; height:12px;" class="mr-1">
                                                    {{ step.status ? 'check_circle' : (step.required !== false ? 'error_outline' : 'radio_button_unchecked') }}
                                                </mat-icon>
                                                <span [class.text-danger]="!step.status && step.required !== false" [class.text-muted]="!step.status && step.required === false">
                                                    {{ step.label | translate }}{{ step.detail ? ': ' + step.detail : '' }}
                                                </span>
                                            </div>
                                        }
                                    </div>
                                    @if (getQuestionValidationMessage(q)) {
                                        <div class="text-muted x-small mt-1 ml-4 italic">
                                            {{ getQuestionValidationMessage(q) | translate }}
                                        </div>
                                    }
                                </div>
                            }
                        </mat-expansion-panel>
                    }

                    @if (answeredQuestions.length > 0) {
                        <mat-expansion-panel class="mb-2 border-left-success shadow-sm">
                            <mat-expansion-panel-header>
                                <mat-panel-title class="text-success font-weight-bold small">{{ 'generic.answered' | translate }} ({{ answeredQuestions.length }})</mat-panel-title>
                            </mat-expansion-panel-header>
                            @for (q of answeredQuestions; track q.id) {
                                <div class="d-flex flex-column py-2 px-1 border-bottom-light">
                                    <div class="d-flex align-items-center mb-1">
                                        <mat-icon class="text-success mr-2" style="font-size: 16px; width:16px; height:16px;">check</mat-icon>
                                        <span class="small font-weight-bold text-muted">{{ q.question }}</span>
                                    </div>
                                    <div class="ml-4 d-flex flex-wrap">
                                        @for (step of getQuestionCompletionSteps(q); track step.label) {
                                            <div class="mr-3 mb-1 d-flex align-items-center x-small text-success opacity-7">
                                                <mat-icon style="font-size: 12px; width:12px; height:12px;" class="mr-1">check_circle</mat-icon>
                                                <span>{{ step.label | translate }}{{ step.detail ? ': ' + step.detail : '' }}</span>
                                            </div>
                                        }
                                    </div>
                                </div>
                            }
                        </mat-expansion-panel>
                    }
                </mat-accordion>
            </div>
        }

        <!-- Detailed View: ONLY if NOT anonymous -->
        @if (!isAnonymous) {
            <app-survey-details [surveyObj]="survey" [isResponse]="true" />
        }
      </div>
    }
  </div>
</div>
}
